module.exports = __webpack_public_path__ + "img/avatar-87.90f32dc4.png";